// types.ts
import type { Member } from '@actschurch/ccms-sdk';

// Use the real SDK type everywhere instead of a hand-rolled duplicate that
// drifts out of sync with it (was missing userId/maritalStatusID/isMember/
// isActive, and had lastName as required instead of optional).
export type member = Member;

export interface StagedCounselee {
  member: member;
  isMain: boolean;
}

export const fullName = (m: member) =>
  [m.firstName, m.lastName].filter(Boolean).join(' ').trim() || `Member ${m.memberID}`;

export const getInitials = (m: member) =>
  [m.firstName?.[0], m.lastName?.[0]].filter(Boolean).join('').toUpperCase() || 'M';

// ── Shared wizard state, passed down to every step ──────────────────────────
export interface WizardState {
  // Step 1
  search: string;
  setSearch: (v: string) => void;
  results: member[];
  searching: boolean;
  staged: StagedCounselee[];
  addCounselee: (m: member, isMain: boolean) => void;
  removeCounselee: (memberID: number) => void;
  setMain: (memberID: number) => void;
  isStaged: (m: member) => boolean;

  // Step 1 — create new member
  allMemberTypes: { typeID: number; name: string }[];
  creatingMember: boolean;
  createMember: (payload: {
    firstName: string;
    lastName: string;
    email: string;
    cellNumber?: string | null;
    typeID: number;
  }) => Promise<member | null>;

  // Step 2
  allNeeds: any[];
  needID: number | null;
  setNeedID: (v: number | null) => void;

  // Step 3
  allLocations: any[];
  allZones: any[];
  allAreas: any[];
  allLeaders: any[];
  locationID: number | null;
  zoneID: number | null;
  areaID: number | null;
  leaderUserId: string | null;
  handleLocationChange: (val: string | null) => void;
  handleZoneChange: (val: string | null) => void;
  handleAreaChange: (val: string | null) => void;
  setLeaderUserId: (v: string | null) => void;

  // Step 4
  caseName: string;
  setCaseName: (v: string) => void;
  description: string;
  setDescription: (v: string) => void;
}